import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { EnquiryProvider } from "@/context/EnquiryContext";
import { EnquiryModal } from "@/components/EnquiryModal";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Organizations from "@/pages/Organizations";
import Foundation from "@/pages/Foundation";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookie from "@/pages/Cookie";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <EnquiryProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/organizations" element={<Organizations />} />
          <Route path="/foundation" element={<Foundation />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookie-policy" element={<Cookie />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <EnquiryModal />
        <Toaster position="top-center" richColors />
      </EnquiryProvider>
    </BrowserRouter>
  );
}

export default App;
